<audio id="remoteAudio" autoplay></audio>

<!-- Active Call Stack -->
@if (isGlobalWidgetExpanded) {
  <div class="active-call-stack">
    @for (sessionData of activeSessionsList(); track trackBySessionId($index, sessionData)) {
      <div class="active-call-card shadow-lg">
        <div class="card-header">
          <div class="d-flex flex-column gap-1 overflow-hidden">
            <h4 class="caller-name">
              <a [routerLink]="['/app/sales/my-leads-details']"
                [queryParams]="{ lead_id: $safeNavigationMigration(sessionData.caller_data?.lead_id) }"
                class="text-dark text-decoration-none">
                {{ sessionData.onCallUserDetails?.username || sessionData.caller_data?.caller || 'Unknown' }}
              </a>
            </h4>
            <div class="badge-row d-flex gap-2">
              <span class="call-badge" [ngClass]="sessionData.type === 'inbound' ? 'badge-incoming' : 'badge-outgoing'">
                <img [src]="sessionData.type === 'inbound' ? 'assets/images/icons/arrow-down-left.png' : 'assets/images/icons/arrow-down-right.png'" alt="">
                {{ sessionData.type === 'inbound' ? 'Incoming' : 'Outgoing' }}
              </span>
            </div>
          </div>
          <div class="timer-badge">
            {{ formattedTime(sessionData.callDuration) }}
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-secondary fw-500">
            {{ (sessionData.onCallUserDetails?.maskedPracticePhoneNumber || 'Unknown Caller') | phoneFormat }}
          </small>
          <a [routerLink]="['/app/leads/details']" [queryParams]="{ id: $safeNavigationMigration(sessionData.caller_data?.lead_id) }"
            class="text-muted text-decoration-none opacity-50 hover-opacity-100">
            <i class="fas fa-external-link-alt small"></i>
          </a>
        </div>
        <div class="card-actions">
          <!-- Mute -->
          <button (click)="phone.toggleMute(sessionData.id)"
            [class.active-state]="sessionData.isMuted"
            title="Mute/Unmute">
            <img [src]="sessionData.isMuted ? 'assets/images/icons/microphone-off.svg' : 'assets/images/icons/microphone-on.svg'"
              [style.filter]="sessionData.isMuted ? 'brightness(0) invert(1)' : 'none'">
            </button>
            <!-- Hold -->
            <button (click)="phone.toggleHold(sessionData.id)"
              [class.active-state]="sessionData.isOnHold"
              title="Hold/Resume">
              <img [src]="sessionData.isOnHold ? 'assets/images/icons/hold.svg' : 'assets/images/icons/resume.svg'"
                [style.filter]="sessionData.isOnHold ? 'brightness(0) invert(1)' : 'none'">
              </button>
              <!-- End Call -->
              <button (click)="phone.endCall(sessionData.id)"
                class="btn-danger"
                title="End Call">
                <img src="assets/images/icons/call-ended.svg">
              </button>
            </div>
          </div>
        }
      </div>
    }

    <!-- Floating Action Button -->
    @if (shouldShowFloatingIcon) {
      <div class="call-fab-container">
        <button (click)="isGlobalWidgetExpanded = !isGlobalWidgetExpanded"
          class="call-fab-btn shadow-lg"
          [ngClass]="{ 'ringing': phone.callState() === callState.RINGING }">
        <img [src]="isGlobalWidgetExpanded 
              ? 'assets/images/png/down.png' 
              : 'assets/images/icons/phone-white-icon.png'">
            <!-- Optional red dot for missed or active calls -->
            @if (!isGlobalWidgetExpanded && activeSessionsList().length > 0) {
              <span
                class="position-absolute translate-middle p-2 bg-danger border border-light rounded-circle"
                style="top: 15%; right: 15%;">
              </span>
            }
          </button>
        </div>
      }
